import {observer} from 'mobx-react';
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget.module.scss";

export const EntityScoresWidgetSectionTitle = observer(({controller, section}) => {
    const {state} = controller
    const {SectionTagTitle} = state;
    const {title} = section;

    return (
      <SectionTagTitle className={classNames(styles.section_title)}>
        <div className={classNames(styles.section_title_line)}/>
        {title}
        <div className={classNames(styles.section_title_line)}/>
      </SectionTagTitle>
    );
  }
);
